import { createSlice } from "@reduxjs/toolkit";
import { signupWithoutKycApi } from "./api";

const initialState = {
  response: {},
  loading: false,
  error: null,
};

const signupWithoutKycSlice = createSlice({
  name: "signupWithoutKycSlice",
  initialState,

  reducers: {
    clearSignupWithoutKycResponse: () => initialState,
  },

  extraReducers: (builder) => {
    builder.addCase(signupWithoutKycApi.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(signupWithoutKycApi.fulfilled, (state, action) => {
      state.response = action.payload;
      state.loading = false;
    });

    builder.addCase(signupWithoutKycApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { clearSignupWithoutKycResponse } = signupWithoutKycSlice.actions;

export default signupWithoutKycSlice.reducer;
